import { render, staticRenderFns } from "./WaveStatusModal.vue?vue&type=template&id=590beff2"
import script from "./WaveStatusModal.vue?vue&type=script&lang=js"
export * from "./WaveStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports